export default "__VITE_ASSET__ClANLloA__"